import React from "react"

const DragonSkull = ({
  colors = [
    "#B5B5AE",
    "#SVGID_",
    "#BF0A00",
    "#E59572",
    "#FFF4BF",
    "#FFF7D2",
    "#FFFBE6",
    "#FFFDF4",
    "#FFFFFD",
    "#FFFFFF",
    "#E7A4A0"
  ]
}) => {
  return (
    <g id="DragonSkull">
      <ellipse
        opacity="0.3"
        fill="#21376C"
        cx="68.5"
        cy="46"
        rx="7.6"
        ry="3.6"
      />
      <path
        opacity="0.3"
        fill="#21376C"
        d="M77.5,46.2000008L60,46.0999985l1.0999985,2.5999985 c0,0.5999985-0.0999985,1.4000015,0.0999985,2c0.0999985-0.7999992,0.7999992-1.5999985,1.2999992-2h0.2999992 c-0.0999985,0.4000015-0.0999985,1.2000008,0.2000008,1.7000008c0-0.2999992,0.2999992-0.7999992,0.5-1.0999985 C63.5999947,49.3999977,63.6999969,49.5,63.7999954,49.5c0,0.4000015,0.0999985,0.7999992,0.3000031,1.0999985 l0.3000031-0.7000008c0.0999985,0.0999985,0.1999969,0.2000008,0.3000031,0.2000008c0,0.7999992,0,1.7999992,0.3000031,2.5 C65.1000061,51.7999992,65.6000061,51.1999969,65.9000092,51H66c0,0,0.0999985,0.0999985,0.0999985,0.2000008 c0,0.5999985,0.0999985,1.7999992,0.5,2.2000008C66.5999985,53,66.7999954,52.5,67,52.2000008h2.9000015 C70.0999985,52.5,70.3000031,53,70.3000031,53.4000015c0.4000015-0.2999992,0.5-1.5,0.5-2.0999985 C70.9000015,51.2000046,71,51.1000023,71,51.1000023l0,0c0.3000031,0.2999992,0.8000031,0.7999992,0.9000015,1.5999985 C72.2000046,52,72.2000046,51,72.2000046,50.2000008C72.3000031,50.1000023,72.4000015,50,72.6000061,49.9000015L72.9000092,50.5 c0.1999969-0.2999992,0.3000031-0.7000008,0.3000031-1c0.0999985-0.0999985,0.3000031-0.2000008,0.4000015-0.2999992 c0.1999969,0.2999992,0.5,0.7999992,0.5,1.0999985c0.3000031-0.5,0.3000031-1.0999985,0.3000031-1.5999985 c0.0999985,0,0.0999985-0.0999985,0.1999969-0.0999985h0.0999985c0.4000015,0.4000015,1.1999969,1.2000008,1.3000031,2 c0.1999969-0.5999985,0.1999969-1.4000015,0.0999985-2L77.5,46.2000008z"
      />
      <path
        fill={colors[0]}
        d="M78.3000031,46.4000015l-2.1999969-1.5c0,0,2.3000031-4,1.4000015-4c-1.8000031,0.2000008-2.4000015-1-3-2 C74.4000092,38.8000031,74.4000092,38.6000023,74.3000107,38.5c-0.5-1-0.3000031-3.0999985-0.3000031-3.0999985l-1.5,1.2000008 c-1.1999969-1-2.5999985-0.0999985-3.0999985-0.2000008l-0.9000015-3.0999985l-1,3.0999985 c-0.5,0.0999985-1.8000031-0.9000015-3,0.2000008l-1.4000015-1.2000008c0,0,0.2999992,2-0.2000008,2.9000015 c-0.2000008,0.2999992-0.4000015,0.5999985-0.4000015,0.7999992c-0.2999992,1.0999985-0.7000008,2.2999992-2.9000015,2.2999992 c-0.5999985,0,1.4000015,3.5,1.4000015,3.5l-2.2000008,1.5H61c0,0.4000015-0.0999985,0.9000015,0.0999985,1.2999992 c0.0999985-0.5,0.7999992-1,1.2999992-1.2999992h0.2999992C62.5999985,46.7000008,62.5999985,47.1000023,62.8999977,47.5 c0-0.2000008,0.2999992-0.5,0.5-0.7000008c0.0999985,0,0.2000008,0.0999985,0.2999992,0.2000008 c0,0.2000008,0.0999985,0.5,0.2999992,0.7000008l0.2999992-0.4000015 c0.0999985,0.0999985,0.1999969,0.0999985,0.3000031,0.2000008c0,0.5,0,1.0999985,0.3000031,1.5999985 c0.0999985-0.5,0.5999985-0.9000015,0.9000015-1h0.0999985c0,0,0.0999985,0,0.0999985,0.0999985 c0,0.4000015,0.0999985,1.0999985,0.5,1.4000015c0-0.2999992,0.1999969-0.5999985,0.4000015-0.7999992h2.9000015 C70,49,70.2000046,49.2999992,70.2000046,49.5999985c0.4000015-0.2000008,0.5-0.9000015,0.5-1.2999992 c0.0999985-0.0999985,0.1999969-0.0999985,0.1999969-0.0999985l0,0c0.3000031,0.2000008,0.8000031,0.5,0.9000015,1 c0.3000031-0.4000015,0.3000031-1.0999985,0.3000031-1.5c0.0999985-0.0999985,0.1999969-0.0999985,0.4000015-0.2000008 l0.3000031,0.4000015c0.1999969-0.2000008,0.3000031-0.4000015,0.3000031-0.5999985 c0.0999985-0.0999985,0.3000031-0.0999985,0.4000015-0.2000008c0.1999969,0.2000008,0.5,0.5,0.5,0.7000008 c0.3000031-0.2999992,0.3000031-0.7000008,0.3000031-1c0.0999985,0,0.0999985-0.0999985,0.1999969-0.0999985h0.0999985 c0.4000015,0.2999992,1.1999969,0.7999992,1.3000031,1.2999992c0.1999969-0.4000015,0.1999969-0.9000015,0.0999985-1.2999992 h2.3000031v-0.3000031H78.3000031z"
      />
      <path
        fill="url(#SVGID_8_)"
        d="M76,43.2999992c0-0.0999985-0.3000031,0.4000015-0.5,1 c-0.0999985-0.4000015-0.4000015-0.5999985-0.4000015-0.4000015c0,0.0999985,0,0.7999992,0,0.9000015 c0,0.2000008-0.1999969-0.9000015-0.1999969-0.5999985c-0.0999985,0-0.3000031,0.2000008-0.4000015,0.2999992 s0,0.7999992-0.0999985,0.7999992s-0.0999985-0.5-0.1999969-0.5999985c-0.1999969,0-0.5,0.0999985-0.5,0.0999985 c-0.0999985,0-0.0999985,0.5-0.0999985,1.2999992c-0.0999985,0-0.1999969-0.9000015-0.4000015-1.0999985 c-0.1999969,0-0.3000031,0-0.5-0.0999985c-0.1999969,0-0.4000015-0.0999985-0.4000015,0 c0,0,0.1999969,1.0999985,0.0999985,1.0999985s-0.1999969-0.9000015-0.5-1.0999985c-0.3000031,0.0999985-0.8000031,0-0.8000031,0 l-0.1999969,1.2999992l-0.1999969-1.4000015c0,0-0.1999969-0.0999985-0.5-0.2000008 C70.0000076,44.5,69.9000015,46.0999985,69.8000031,46C69.5,45.9000015,69,44.5,68.9000015,44.0999985 c0-0.0999985,0-0.2000008,0-0.2000008s-0.5999985,2-1,2c-0.0999985,0-0.1999969-1.5-0.4000015-1.4000015 c-0.3000031,0.0999985-0.5,0.2000008-0.5,0.2000008l-0.1999969,1.4000015l-0.1999969-1.2999992c0,0-0.5,0-0.8000031,0 C65.6000061,45,65.5,45.8999977,65.3000031,45.8999977c-0.0999985,0,0.0999985-1.0999985,0.0999985-1.0999985 s-0.1999969,0-0.4000015,0c-0.1999969,0-0.3000031,0-0.5,0.0999985c-0.1999969,0.2000008-0.3000031,1.0999985-0.4000015,1.0999985 C64.0999985,45.1999969,64,44.6999969,64,44.6999969c-0.0999985,0-0.2999992-0.0999985-0.5-0.0999985 c-0.0999985,0.0999985-0.0999985,0.5999985-0.2000008,0.5999985c-0.0999985,0,0-0.7000008-0.0999985-0.7999992 c-0.0999985,0-0.2999992-0.2000008-0.4000015-0.2999992c0-0.2999992-0.2000008,0.7999992-0.2000008,0.5999985 c0-0.0999985,0-0.7999992,0-0.9000015c-0.0999985-0.2000008-0.2999992,0-0.4000015,0.4000015c-0.2000008-0.5999985-0.5-1-0.5-1 c0,0.0999985,0.2000008,1.5999985,0.2000008,1.5999985L61.0999985,46v0.0999985c0,0,0.5999985-0.5999985,0.9000015-0.7000008 c0.2999992-0.0999985,0.4000015,0.7000008,0.4000015,0.7000008l0.2999992,0.0999985c0,0,0.2000008-0.2999992,0.4000015-0.4000015 c0.2000008,0,0.0999985,0.5999985,0.0999985,0.5999985L63.5,46.5999947c0,0,0.0999985-0.5999985,0.4000015-0.2999992 c0.3000031,0.2000008,0.1999969,0.5999985,0.1999969,0.5999985S64.4000015,47.0999947,64.5,46.9999924 c0-0.0999985,0.5999985-0.7000008,0.8000031-0.5999985c0.1999969,0.0999985,0.3000031,1.2000008,0.3000031,1.2000008 l0.1999969,0.2000008c0,0,0.4000015-0.9000015,0.5999985-0.7999992c0.1999969,0.0999985,0.3000031,0.9000015,0.3000031,0.9000015 l0.4000015-0.2000008c0,0,0.1999969,0.0999985,0.1999969,0.2000008c0,0.0999985,0.4000015,0.0999985,0.5999985,0 C68,47.8999977,68,47.1999969,68,46.4999962c0,0.7999992,0,1.4000015,0.0999985,1.5c0.1999969,0.0999985,0.5999985,0,0.5999985,0 l0.1999969-0.2000008l0.4000015,0.2000008c0,0,0.0999985-0.9000015,0.3000031-0.9000015 c0.1999969-0.0999985,0.5999985,0.7999992,0.5999985,0.7999992l0.1999969-0.2000008c0,0,0.0999985-1.0999985,0.3000031-1.2000008 C70.8999939,46.3999939,71.5,47.0999908,71.5,47.0999908c0,0.0999985,0.4000015-0.0999985,0.4000015-0.0999985 s0-0.4000015,0.1999969-0.5999985C72.4000015,46.1999931,72.5,46.6999931,72.5,46.6999931l0.3000031-0.2000008 c0,0-0.0999985-0.7000008,0.0999985-0.5999985c0.1999969,0,0.4000015,0.4000015,0.4000015,0.4000015l0.3000031-0.0999985 c0,0,0.0999985-0.7999992,0.4000015-0.7000008s0.9000015,0.7000008,0.9000015,0.7000008v-0.0999985l-0.1999969-1.2000008 C75.8000031,44.7999992,76,43.4000015,76,43.2999992z"
      />
      <path
        opacity="0.41"
        d="M62.9000015,41.5999985C63.1000023,40.8999977,64.9000015,38,65.5999985,38 c0.5999985,0,1,0.2999992,1.4000015,0.5999985C67,38.5,67,38.5,66.9000015,38.3999977 c-0.5-0.4000015-1-0.9000015-1.6999969-0.9000015s-2.5,2.9000015-2.7000008,3.5999985 c-0.0999985,0.2000008,0.0999985,1.5999985,0.5999985,1.7999992h0.0999985 C62.9000015,42.5,62.7999992,41.7000008,62.9000015,41.5999985z"
      />
      <path
        opacity="0.41"
        d="M65.0999985,42.5999985 C65.5,42.2999992,67.4000015,38.8999977,66.9000015,38.5s-1-0.9000015-1.6999969-0.9000015s-2.5,2.9000015-2.7000008,3.5999985 c-0.0999985,0.2000008,0.0999985,1.5999985,0.5999985,1.7999992C63.5,43.2000008,64.6999969,42.9000015,65.0999985,42.5999985z"
      />
      <path
        opacity="0.41"
        d="M67.0999985,43.9000015L65.5,44.2000008l1.9000015-2.2999992 C67.5,41.9000015,68.0999985,43.2000008,67.0999985,43.9000015z"
      />
      <polygon
        opacity="0.41"
        points="66.0999985,44.0999985 67.5999985,42.2000008 67.5,41.9000015 65.5999985,44.2000008"
      />
      <path
        opacity="0.41"
        d="M62.9000015,41.5999985C63.1000023,40.8999977,64.9000015,38,65.5999985,38 c0.5999985,0,1,0.2999992,1.4000015,0.5999985C67,38.5,67,38.5,66.9000015,38.3999977 c-0.5-0.4000015-1-0.9000015-1.6999969-0.9000015s-2.5,2.9000015-2.7000008,3.5999985 c-0.0999985,0.2000008,0.0999985,1.5999985,0.5999985,1.7999992h0.0999985 C62.9000015,42.5,62.7999992,41.7000008,62.9000015,41.5999985z"
      />
      <path
        opacity="0.41"
        d="M65.0999985,42.5999985 C65.5,42.2999992,67.4000015,38.8999977,66.9000015,38.5s-1-0.9000015-1.6999969-0.9000015s-2.5,2.9000015-2.7000008,3.5999985 c-0.0999985,0.2000008,0.0999985,1.5999985,0.5999985,1.7999992C63.5,43.2000008,64.6999969,42.9000015,65.0999985,42.5999985z"
      />
      <path
        opacity="0.41"
        d="M67.0999985,43.9000015L65.5,44.2000008l1.9000015-2.2999992 C67.5,41.9000015,68.0999985,43.2000008,67.0999985,43.9000015z"
      />
      <polygon
        opacity="0.41"
        points="66.0999985,44.0999985 67.5999985,42.2000008 67.5,41.9000015 65.5999985,44.2000008"
      />
      <g>
        <path
          opacity="0.41"
          d="M74.3000031,41.5c-0.1999969-0.7000008-2-3.5999985-2.6999969-3.5999985 c-0.5999985,0-1,0.2999992-1.4000015,0.5999985c0-0.0999985,0-0.0999985,0.0999985-0.2000008 c0.5-0.4000015,1-0.9000015,1.6999969-0.9000015s2.5,2.9000015,2.6999969,3.5999985 c0.0999985,0.2000008-0.0999985,1.5999985-0.5999985,1.7999992H74C74.1999969,42.4000015,74.3000031,41.7000008,74.3000031,41.5z"
        />
        <path
          opacity="0.41"
          d="M72,42.5c-0.4000015-0.2999992-2.3000031-3.7000008-1.8000031-4.0999985 c0.5-0.4000015,1-0.9000015,1.6999969-0.9000015s2.5,2.9000015,2.6999969,3.5999985 c0.0999985,0.2000008-0.0999985,1.5999985-0.5999985,1.7999992S72.4000015,42.7999992,72,42.5z"
        />
      </g>
      <g>
        <path
          opacity="0.41"
          d="M70,43.7999992l1.5999985,0.2999992l-1.9000015-2.2999992 C69.6999969,41.7999992,69,43.0999985,70,43.7999992z"
        />
        <polygon
          opacity="0.41"
          points="71.0999985,44 69.5,42.0999985 69.6999969,41.7999992 71.5,44.0999985"
        />
      </g>
      <g>
        <linearGradient
          id="SVGID_9_"
          gradientUnits="userSpaceOnUse"
          x1="68.498"
          y1="-538.886"
          x2="68.776"
          y2="-515.653"
          gradientTransform="matrix(1 0 0 -1 0 -488)"
        >
          <stop offset="0" stopColor={colors[2]} />
          <stop offset="0" stopColor={colors[3]} stopOpacity="0.936" />
          <stop offset="0" stopColor={colors[4]} stopOpacity="0.89" />
          <stop offset="0.079" stopColor={colors[5]} stopOpacity="0.795" />
          <stop offset="0.191" stopColor={colors[6]} stopOpacity="0.661" />
          <stop offset="0.319" stopColor={colors[7]} stopOpacity="0.507" />
          <stop offset="0.476" stopColor={colors[8]} stopOpacity="0.319" />
          <stop offset="0.742" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="SVGID_10_"
          gradientUnits="userSpaceOnUse"
          x1="68.684"
          y1="-515.829"
          x2="68.653"
          y2="-532.956"
          gradientTransform="matrix(1 0 0 -1 0 -488)"
        >
          <stop offset="0.059" stopColor={colors[2]} />
          <stop offset="0.522" stopColor={colors[10]} stopOpacity="0.383" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_9_)"
          d="M78.3000031,46.4000015l-2.1999969-1.5c0,0,2.3000031-4,1.4000015-4 c-1.8000031,0.2000008-2.4000015-1-3-2C74.4000092,38.8000031,74.4000092,38.6000023,74.3000107,38.5 c-0.5-1-0.3000031-3.0999985-0.3000031-3.0999985l-1.5,1.2000008c-1.1999969-1-2.5999985-0.0999985-3.0999985-0.2000008 l-0.9000015-3.0999985l-1,3.0999985c-0.5,0.0999985-1.8000031-0.9000015-3,0.2000008l-1.4000015-1.2000008 c0,0,0.2999992,2-0.2000008,2.9000015c-0.2000008,0.2999992-0.4000015,0.5999985-0.4000015,0.7999992 c-0.2999992,1.0999985-0.7000008,2.2999992-2.9000015,2.2999992c-0.5999985,0,1.4000015,3.5,1.4000015,3.5l-2.2000008,1.5H61 c0,0.4000015-0.0999985,0.9000015,0.0999985,1.2999992c0.0999985-0.5,0.7999992-1,1.2999992-1.2999992h0.2999992 C62.5999985,46.7000008,62.5999985,47.1000023,62.8999977,47.5c0-0.2000008,0.2999992-0.5,0.5-0.7000008 c0.0999985,0,0.2000008,0.0999985,0.2999992,0.2000008c0,0.2000008,0.0999985,0.5,0.2999992,0.7000008l0.2999992-0.4000015 c0.0999985,0.0999985,0.1999969,0.0999985,0.3000031,0.2000008c0,0.5,0,1.0999985,0.3000031,1.5999985 c0.0999985-0.5,0.5999985-0.9000015,0.9000015-1h0.0999985c0,0,0.0999985,0,0.0999985,0.0999985 c0,0.4000015,0.0999985,1.0999985,0.5,1.4000015c0-0.2999992,0.1999969-0.5999985,0.4000015-0.7999992h2.9000015 C70,49,70.2000046,49.2999992,70.2000046,49.5999985c0.4000015-0.2000008,0.5-0.9000015,0.5-1.2999992 c0.0999985-0.0999985,0.1999969-0.0999985,0.1999969-0.0999985l0,0c0.3000031,0.2000008,0.8000031,0.5,0.9000015,1 c0.3000031-0.4000015,0.3000031-1.0999985,0.3000031-1.5c0.0999985-0.0999985,0.1999969-0.0999985,0.4000015-0.2000008 l0.3000031,0.4000015c0.1999969-0.2000008,0.3000031-0.4000015,0.3000031-0.5999985 c0.0999985-0.0999985,0.3000031-0.0999985,0.4000015-0.2000008c0.1999969,0.2000008,0.5,0.5,0.5,0.7000008 c0.3000031-0.2999992,0.3000031-0.7000008,0.3000031-1c0.0999985,0,0.0999985-0.0999985,0.1999969-0.0999985h0.0999985 c0.4000015,0.2999992,1.1999969,0.7999992,1.3000031,1.2999992c0.1999969-0.4000015,0.1999969-0.9000015,0.0999985-1.2999992 h2.3000031v-0.3000031H78.3000031z"
        />
        <path
          fill="url(#SVGID_10_)"
          d="M78.4000015,46.2999992l-2.1999969-1.5c0,0,2.3000031-4,1.4000015-4 c-1.8000031,0.2000008-2.4000015-1-3-2C74.5000076,38.7000008,74.5000076,38.5,74.4000092,38.3999977 c-0.5-1-0.3000031-3.0999985-0.3000031-3.0999985l-1.5,1.2000008c-1.1999969-1-2.5999985-0.0999985-3.0999985-0.2000008 l-0.9000015-3.0999985l-1,3.0999985c-0.5,0.0999985-1.8000031-0.9000015-3,0.2000008l-1.4000015-1.2000008 c0,0,0.2999992,2-0.2000008,2.9000015C62.8000031,38.5,62.6000023,38.7999992,62.6000023,39 c-0.2999992,1.0999985-0.7000008,2.2999992-2.9000015,2.2999992c-0.5999985,0,1.4000015,3.5,1.4000015,3.5l-2.2000008,1.5 h2.2000008c0,0.4000015-0.0999985,0.9000015,0.0999985,1.2999992c0.0999985-0.5,0.7999992-1,1.2999992-1.2999992h0.2999992 C62.7000008,46.5999985,62.7000008,47,63,47.3999977c0-0.2000008,0.2999992-0.5,0.5-0.7000008 c0.0999985,0,0.2000008,0.0999985,0.2999992,0.2000008c0,0.2000008,0.0999985,0.5,0.2999992,0.7000008l0.3000031-0.4000015 c0.0999985,0.0999985,0.1999969,0.0999985,0.3000031,0.2000008c0,0.5,0,1.0999985,0.3000031,1.5999985 c0.0999985-0.5,0.5999985-0.9000015,0.9000015-1H66c0,0,0.0999985,0,0.0999985,0.0999985 c0,0.4000015,0.0999985,1.0999985,0.5,1.4000015c0-0.2999992,0.1999969-0.5999985,0.4000015-0.7999992h3 c0.1999969,0.2000008,0.4000015,0.5,0.4000015,0.7999992c0.4000015-0.2000008,0.5-0.9000015,0.5-1.2999992 C71,48.0999985,71.0999985,48.0999985,71.0999985,48.0999985l0,0c0.3000031,0.2000008,0.8000031,0.5,0.9000015,1 c0.3000031-0.4000015,0.3000031-1.0999985,0.3000031-1.5C72.4000015,47.5,72.5,47.5,72.7000046,47.3999977l0.3000031,0.4000015 c0.1999969-0.2000008,0.3000031-0.4000015,0.3000031-0.5999985C73.4000092,47.1000023,73.6000137,47.1000023,73.7000122,47 c0.1999969,0.2000008,0.5,0.5,0.5,0.7000008c0.3000031-0.2999992,0.3000031-0.7000008,0.3000031-1 c0.0999985,0,0.0999985-0.0999985,0.1999969-0.0999985h0.0999985c0.4000015,0.2999992,1.1999969,0.7999992,1.3000031,1.2999992 C76.3000107,47.5,76.3000107,47,76.2000122,46.6000023h2.1999969 C78.4000092,46.6000023,78.4000092,46.2999992,78.4000015,46.2999992z"
        />
        <linearGradient
          id="SVGID_11_"
          gradientUnits="userSpaceOnUse"
          x1="66.597"
          y1="-535.164"
          x2="66.594"
          y2="-537.317"
          gradientTransform="matrix(1 0 0 -1 0 -488)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_11_)"
          d="M66.6999969,47.2000008C66.5,47.7999992,66.0999985,48.2999992,66.3999939,48.9000015 c0,0.0999985,0.3000031,0.2000008,0.1999969,0c-0.3000031-0.5,0.0999985-1.0999985,0.3000031-1.5999985 C66.9000015,47.2999992,66.6999969,47.0999985,66.6999969,47.2000008L66.6999969,47.2000008z"
        />
        <linearGradient
          id="SVGID_12_"
          gradientUnits="userSpaceOnUse"
          x1="65.266"
          y1="-534.325"
          x2="65.262"
          y2="-536.685"
          gradientTransform="matrix(1 0 0 -1 0 -488)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_12_)"
          d="M65.5,46.7000008c-0.5999985,0.5-0.5999985,1.2000008-0.6999969,1.9000015 C64.8000031,48.7000008,65,48.8000031,65,48.8000031c0.0999985-0.7000008,0.0999985-1.4000015,0.6999969-1.7999992 C65.8000031,46.7999992,65.5999985,46.5999985,65.5,46.7000008L65.5,46.7000008z"
        />
        <linearGradient
          id="SVGID_13_"
          gradientUnits="userSpaceOnUse"
          x1="64.064"
          y1="-534.324"
          x2="64.062"
          y2="-535.643"
          gradientTransform="matrix(1 0 0 -1 0 -488)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_13_)"
          d="M64,46.4000015C63.9000015,46.7000008,63.9000015,47,64,47.3000031 c0,0.0999985,0.1999969,0.2000008,0.1999969,0.0999985c-0.0999985-0.2999992-0.0999985-0.5999985,0-0.9000015 C64.1999969,46.5,64,46.2999992,64,46.4000015L64,46.4000015z"
        />
        <linearGradient
          id="SVGID_14_"
          gradientUnits="userSpaceOnUse"
          x1="63.102"
          y1="-533.82"
          x2="63.099"
          y2="-535.204"
          gradientTransform="matrix(1 0 0 -1 0 -488)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_14_)"
          d="M63.2000008,46.2000008c-0.2999992,0.2999992-0.4000015,0.5-0.4000015,0.9000015 C62.7999992,47.2000008,63,47.3000031,63,47.3000031c0-0.4000015,0.0999985-0.7000008,0.4000015-0.9000015 C63.4000015,46.2999992,63.2000008,46.0999985,63.2000008,46.2000008L63.2000008,46.2000008z"
        />
        <linearGradient
          id="SVGID_15_"
          gradientUnits="userSpaceOnUse"
          x1="61.566"
          y1="-533.134"
          x2="61.562"
          y2="-535.341"
          gradientTransform="matrix(1 0 0 -1 0 -488)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_15_)"
          d="M62.0999985,45.5c-0.5999985,0.2999992-1,0.9000015-1.2000008,1.5999985 c0,0.0999985,0.2000008,0.2000008,0.2000008,0.2000008c0.0999985-0.7000008,0.5-1.2999992,1.0999985-1.5999985 C62.2999992,45.7000008,62.0999985,45.5,62.0999985,45.5L62.0999985,45.5z"
        />
        <linearGradient
          id="SVGID_16_"
          gradientUnits="userSpaceOnUse"
          x1="66.577"
          y1="-534.969"
          x2="66.573"
          y2="-537.201"
          gradientTransform="matrix(1 0 0 -1 0 -488)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_16_)"
          d="M66.6999969,47.2999992c-0.4000015,0.5-0.5,1.0999985-0.4000015,1.7000008 c0,0.0999985,0.1999969,0.2000008,0.1999969,0.0999985c-0.1999969-0.5999985,0-1.2000008,0.3000031-1.5999985 C67,47.4000015,66.8000031,47.2000008,66.6999969,47.2999992L66.6999969,47.2999992z"
        />
        <g>
          <linearGradient
            id="SVGID_17_"
            gradientUnits="userSpaceOnUse"
            x1="66.514"
            y1="-535.07"
            x2="66.51"
            y2="-537.331"
            gradientTransform="matrix(1 0 0 -1 0 -488)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_17_)"
            d="M66.5999985,47.4000015c-0.4000015,0.5-0.5,1.0999985-0.1999969,1.7000008 c0,0.0999985,0.1999969,0.2000008,0.1999969,0.0999985c-0.1999969-0.5-0.0999985-1.0999985,0.1999969-1.5999985 C66.8000031,47.5,66.5999985,47.2999992,66.5999985,47.4000015L66.5999985,47.4000015z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_18_"
            gradientUnits="userSpaceOnUse"
            x1="65.184"
            y1="-534.375"
            x2="65.18"
            y2="-536.789"
            gradientTransform="matrix(1 0 0 -1 0 -488)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_18_)"
            d="M65.4000015,46.7000008c-0.5,0.5-0.8000031,1.2000008-0.5999985,1.9000015 C64.8000031,48.7000008,65,48.8000031,65,48.7000008C64.9000015,48,65.0999985,47.4000015,65.5999985,46.9000015 C65.6999969,46.9000015,65.5,46.7000008,65.4000015,46.7000008L65.4000015,46.7000008z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_19_"
            gradientUnits="userSpaceOnUse"
            x1="65.2"
            y1="-534.385"
            x2="65.197"
            y2="-536.18"
            gradientTransform="matrix(1 0 0 -1 0 -488)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_19_)"
            d="M65.4000015,46.7999992c-0.1999969,0.0999985-0.4000015,0.2999992-0.5,0.5s0,0.5,0,0.7999992 c0,0.0999985,0.1999969,0.2000008,0.1999969,0.0999985c0-0.2999992-0.0999985-0.5999985,0-0.7999992 S65.4000015,47.0999985,65.5,46.9999962C65.5999985,46.9000015,65.5,46.7000008,65.4000015,46.7999992L65.4000015,46.7999992z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_20_"
            gradientUnits="userSpaceOnUse"
            x1="64.107"
            y1="-534.095"
            x2="64.104"
            y2="-535.808"
            gradientTransform="matrix(1 0 0 -1 0 -488)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_20_)"
            d="M64.0999985,46.5c-0.2999992,0.2999992-0.2000008,0.7000008,0,1 c0.0999985,0.0999985,0.1999969,0.0999985,0.0999985-0.0999985c-0.2000008-0.2000008-0.0999985-0.5,0.0999985-0.7000008 C64.3000031,46.5999985,64.0999985,46.4000015,64.0999985,46.5L64.0999985,46.5z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_21_"
            gradientUnits="userSpaceOnUse"
            x1="64.036"
            y1="-533.987"
            x2="64.033"
            y2="-535.824"
            gradientTransform="matrix(1 0 0 -1 0 -488)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_21_)"
            d="M64,46.4000015C63.5999985,46.7000008,63.7999992,47.1000023,64,47.5 c0,0.0999985,0.3000031,0.2000008,0.1999969,0c-0.2000008-0.2999992-0.2999992-0.7000008,0.0999985-0.9000015 C64.3000031,46.5999985,64.0999985,46.4000015,64,46.4000015L64,46.4000015z"
          />
          <g>
            <linearGradient
              id="SVGID_22_"
              gradientUnits="userSpaceOnUse"
              x1="63.139"
              y1="-533.602"
              x2="63.136"
              y2="-535.377"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_22_)"
              d="M63.2999992,46c-0.4000015,0.2000008-0.5999985,0.5999985-0.5,1 C62.7999992,47.0999985,63,47.2000008,63,47.0999985c-0.0999985-0.4000015,0.0999985-0.7999992,0.5-1 C63.5,46.2000008,63.4000015,46,63.2999992,46L63.2999992,46z"
            />
            <linearGradient
              id="SVGID_23_"
              gradientUnits="userSpaceOnUse"
              x1="63.097"
              y1="-533.745"
              x2="63.094"
              y2="-535.712"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_23_)"
              d="M63.2000008,46.0999985c-0.4000015,0.2999992-0.5,0.7999992-0.4000015,1.2999992 C62.7999992,47.4999962,63,47.5999985,63,47.4999962c-0.2000008-0.5,0-0.9000015,0.4000015-1.2000008 C63.5,46.2999992,63.2999992,46.0999985,63.2000008,46.0999985L63.2000008,46.0999985z"
            />
            <linearGradient
              id="SVGID_24_"
              gradientUnits="userSpaceOnUse"
              x1="61.64"
              y1="-533.088"
              x2="61.635"
              y2="-536.001"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_24_)"
              d="M62.0999985,45.5999985c-0.5-0.0999985-0.9000015,0.4000015-1,0.7999992 C61,46.6999969,61,47.1999969,61.1999969,47.4999962c0.0999985,0.0999985,0.2000008,0.0999985,0.0999985-0.0999985 c-0.0999985-0.0999985,0-0.7999992,0-0.9000015c0.0999985-0.2999992,0.5-0.7999992,0.9000015-0.7000008 C62.2999992,45.7999992,62.2000008,45.5999985,62.0999985,45.5999985L62.0999985,45.5999985z"
            />
            <linearGradient
              id="SVGID_25_"
              gradientUnits="userSpaceOnUse"
              x1="61.793"
              y1="-533.323"
              x2="61.789"
              y2="-535.549"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_25_)"
              d="M62.0999985,45.7999992C61.5,46.0999985,61.1999969,46.7000008,61.2999992,47.3999977 c0,0.0999985,0.2000008,0.2000008,0.2000008,0.0999985c-0.0999985-0.7000008,0.2000008-1.2000008,0.7999992-1.5 C62.2999992,46,62.2000008,45.7000008,62.0999985,45.7999992L62.0999985,45.7999992z"
            />
            <linearGradient
              id="SVGID_26_"
              gradientUnits="userSpaceOnUse"
              x1="61.673"
              y1="-533.013"
              x2="61.669"
              y2="-535.259"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_26_)"
              d="M62.2000008,45.4000015C61.9000015,45.5,61.5,45.7000008,61.2999992,46 C61,46.2999992,61,46.7000008,61,47.0999985c0,0.0999985,0.2000008,0.2000008,0.2000008,0.2000008 c0-0.4000015,0-0.7999992,0.2000008-1.0999985s0.5999985-0.4000015,0.9000015-0.5 C62.4000015,45.5999985,62.2999992,45.4000015,62.2000008,45.4000015L62.2000008,45.4000015z"
            />
            <linearGradient
              id="SVGID_27_"
              gradientUnits="userSpaceOnUse"
              x1="70.549"
              y1="-534.879"
              x2="70.545"
              y2="-537.302"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_27_)"
              d="M70.3000031,47.2999992c0.4000015,0.5,0.4000015,1.0999985,0.0999985,1.5999985 c0,0.0999985,0.1999969,0.2999992,0.1999969,0.2000008C71,48.5,70.9000015,47.7999992,70.3000031,47.2999992 C70.3000031,47.0999985,70.1999969,47.2000008,70.3000031,47.2999992L70.3000031,47.2999992z"
            />
            <linearGradient
              id="SVGID_28_"
              gradientUnits="userSpaceOnUse"
              x1="70.529"
              y1="-535.035"
              x2="70.524"
              y2="-537.443"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_28_)"
              d="M70.3000031,47.4000015c0.4000015,0.5,0.4000015,1.0999985,0.0999985,1.7000008 c0,0.0999985,0.1999969,0.2000008,0.1999969,0.2000008c0.3000031-0.5999985,0.1999969-1.2999992-0.0999985-1.9000015 C70.4000015,47.2999992,70.1999969,47.2000008,70.3000031,47.4000015L70.3000031,47.4000015z"
            />
            <linearGradient
              id="SVGID_29_"
              gradientUnits="userSpaceOnUse"
              x1="71.767"
              y1="-534.257"
              x2="71.763"
              y2="-536.735"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_29_)"
              d="M71.5,46.7000008c0.5,0.5,0.4000015,1.2999992,0.4000015,1.9000015 c0,0.0999985,0.1999969,0.2000008,0.1999969,0.2000008C72.0999985,48,72.1999969,47.2999992,71.5,46.7000008 C71.4000015,46.5,71.4000015,46.5999985,71.5,46.7000008L71.5,46.7000008z"
            />
            <linearGradient
              id="SVGID_30_"
              gradientUnits="userSpaceOnUse"
              x1="71.971"
              y1="-534.327"
              x2="71.966"
              y2="-536.719"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_30_)"
              d="M71.8000031,47c0.4000015,0.2000008,0.0999985,1.2000008,0.0999985,1.5 c0,0.0999985,0.1999969,0.2000008,0.1999969,0.2000008c0.1999969-0.5999985,0.4000015-1.5999985-0.4000015-1.9000015 C71.5999985,46.7999992,71.6999969,47,71.8000031,47L71.8000031,47z"
            />
            <linearGradient
              id="SVGID_31_"
              gradientUnits="userSpaceOnUse"
              x1="71.887"
              y1="-534.398"
              x2="71.885"
              y2="-535.91"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_31_)"
              d="M71.5999985,46.7999992C71.9000015,47.0999985,72,47.3999977,72,47.7999992 C72,47.8999977,72.1999969,48,72.1999969,48C72.1999969,47.5,72,47.2000008,71.5999985,46.7999992 C71.6999969,46.7000008,71.5,46.5999985,71.5999985,46.7999992L71.5999985,46.7999992z"
            />
            <linearGradient
              id="SVGID_32_"
              gradientUnits="userSpaceOnUse"
              x1="73.121"
              y1="-534.395"
              x2="73.118"
              y2="-535.861"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_32_)"
              d="M73,46.5999985c0.0999985,0.2999992,0,0.5999985-0.0999985,0.7999992 c0,0.0999985,0.1999969,0.2999992,0.1999969,0.2000008c0.1999969-0.2999992,0.3000031-0.5,0.1999969-0.9000015 C73.0999985,46.5999985,72.9000015,46.5,73,46.5999985L73,46.5999985z"
            />
            <linearGradient
              id="SVGID_33_"
              gradientUnits="userSpaceOnUse"
              x1="74.064"
              y1="-533.689"
              x2="74.062"
              y2="-535.199"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_33_)"
              d="M74,46.0999985L74,46.0999985C73.9000015,46.0999985,73.9000015,46.0999985,74,46.0999985 C74,46.3999977,74,46.6999969,74,47c0,0.0999985,0.1999969,0.2000008,0.1999969,0.2000008 c0-0.2999992,0-0.5-0.0999985-0.7999992c0-0.0999985-0.0999985-0.0999985,0-0.0999985 C74.1999969,46.2999992,74.0999985,46.0999985,74,46.0999985L74,46.0999985z"
            />
            <linearGradient
              id="SVGID_34_"
              gradientUnits="userSpaceOnUse"
              x1="75.43"
              y1="-533.179"
              x2="75.426"
              y2="-535.253"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_34_)"
              d="M75.0999985,45.7000008C75.5,46,75.5,46.5,75.5999985,47 c0,0.0999985,0.1999969,0.2000008,0.1999969,0.0999985C75.6999969,46.3999977,75.5999985,45.8999977,75.0999985,45.5 C75,45.5,75.0999985,45.7000008,75.0999985,45.7000008L75.0999985,45.7000008z"
            />
            <linearGradient
              id="SVGID_35_"
              gradientUnits="userSpaceOnUse"
              x1="75.638"
              y1="-533.493"
              x2="75.635"
              y2="-534.908"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_35_)"
              d="M75.4000015,45.7999992c0.1999969,0.2999992,0.3000031,0.5999985,0.3000031,1 C75.7000046,46.8999977,75.9000015,47,75.9000015,47c0-0.4000015-0.0999985-0.7999992-0.3000031-1.0999985 C75.5,45.7999992,75.3000031,45.7000008,75.4000015,45.7999992L75.4000015,45.7999992z"
            />
            <linearGradient
              id="SVGID_36_"
              gradientUnits="userSpaceOnUse"
              x1="75.788"
              y1="-533.719"
              x2="75.786"
              y2="-534.848"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_36_)"
              d="M75.5999985,46c0.0999985,0.2000008,0.1999969,0.4000015,0.1999969,0.7000008 c0,0.0999985,0.1999969,0.2000008,0.1999969,0.2000008c0-0.2999992-0.0999985-0.5-0.1999969-0.7999992 C75.6999969,46,75.5,45.9000015,75.5999985,46L75.5999985,46z"
            />
            <linearGradient
              id="SVGID_37_"
              gradientUnits="userSpaceOnUse"
              x1="66.374"
              y1="-525.154"
              x2="66.364"
              y2="-530.89"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_37_)"
              d="M66.0999985,37.7000008C66.5999985,38.1000023,67,38.5,66.9000015,39.1000023 C66.8000031,39.5000038,66.5999985,39.9000015,66.5,40.3000031 c-0.3000031,0.7999992-0.5999985,1.5999985-0.9000015,2.2999992c0,0.0999985,0.1999969,0.2999992,0.1999969,0.2000008 c0.4000015-1.2000008,1-2.4000015,1.3000031-3.5999985C67.3000031,38.5,66.5999985,38,66.0999985,37.7000008 C66,37.4000015,66,37.5999985,66.0999985,37.7000008L66.0999985,37.7000008z"
            />
            <linearGradient
              id="SVGID_38_"
              gradientUnits="userSpaceOnUse"
              x1="70.473"
              y1="-524.901"
              x2="70.464"
              y2="-529.691"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_38_)"
              d="M71.0999985,37.2999992C70.5,37.7000008,69.6999969,38,69.6999969,38.8999977 c0.0999985,0.9000015,0.9000015,1.7000008,0.6999969,2.5c0,0.0999985,0.1999969,0.2000008,0.1999969,0.2000008 c0.0999985-0.7000008-0.4000015-1.4000015-0.5999985-2c-0.1999969-0.5-0.1999969-1,0.1999969-1.4000015 c0.3000031-0.2999992,0.6999969-0.5,1-0.7000008C71.3000031,37.5,71.1999969,37.2000008,71.0999985,37.2999992 L71.0999985,37.2999992z"
            />
            <linearGradient
              id="SVGID_39_"
              gradientUnits="userSpaceOnUse"
              x1="67.488"
              y1="-529.095"
              x2="67.486"
              y2="-530.606"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_39_)"
              d="M67.3000031,42c0.0999985-0.0999985,0.0999985-0.2000008,0.1999969-0.0999985 c0.0999985,0,0.1999969,0.4000015,0.1999969,0.4000015c0,0.0999985,0.1999969,0.2000008,0.1999969,0.0999985 c-0.0999985-0.2000008-0.1999969-0.5999985-0.4000015-0.7999992c-0.1999969-0.2000008-0.3000031,0-0.4000015,0.2000008 C67,41.9000015,67.1999969,42.0999985,67.3000031,42L67.3000031,42z"
            />
            <linearGradient
              id="SVGID_40_"
              gradientUnits="userSpaceOnUse"
              x1="69.573"
              y1="-529.177"
              x2="69.57"
              y2="-530.623"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_40_)"
              d="M70,42c-0.0999985-0.0999985-0.1999969-0.2999992-0.4000015-0.2999992 c-0.3000031-0.0999985-0.4000015,0.2999992-0.5,0.5999985c0,0.0999985,0.1999969,0.2999992,0.1999969,0.2000008 c0.0999985-0.0999985,0.3000031-0.7999992,0.5999985-0.5C70,42.0999985,70.0999985,42.0999985,70,42L70,42z"
            />
            <linearGradient
              id="SVGID_41_"
              gradientUnits="userSpaceOnUse"
              x1="61.001"
              y1="-528.859"
              x2="61"
              y2="-529.855"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_42_"
              gradientUnits="userSpaceOnUse"
              x1="60.288"
              y1="-532.997"
              x2="60.285"
              y2="-534.336"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_43_"
              gradientUnits="userSpaceOnUse"
              x1="63.803"
              y1="-525.453"
              x2="63.797"
              y2="-528.46"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_44_"
              gradientUnits="userSpaceOnUse"
              x1="73.945"
              y1="-526.403"
              x2="73.941"
              y2="-528.839"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_45_"
              gradientUnits="userSpaceOnUse"
              x1="63.701"
              y1="-523.459"
              x2="63.698"
              y2="-525.266"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_46_"
              gradientUnits="userSpaceOnUse"
              x1="68.392"
              y1="-521.509"
              x2="68.387"
              y2="-524.623"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_47_"
              gradientUnits="userSpaceOnUse"
              x1="73.002"
              y1="-523.501"
              x2="72.998"
              y2="-525.187"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_48_"
              gradientUnits="userSpaceOnUse"
              x1="76.223"
              y1="-528.708"
              x2="76.221"
              y2="-529.388"
              gradientTransform="matrix(1 0 0 -1 0 -488)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_49_"
              gradientUnits="userSpaceOnUse"
              x1="-1358.38"
              y1="-532.882"
              x2="-1358.383"
              y2="-534.221"
              gradientTransform="rotate(180 -640.834 -244)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_41_)"
              d="M62.0999985,41.2000008L62.0999985,41.2000008 C62,41.2000008,62,41.1000023,61.8999977,41.1000023l0,0c0,0-0.0999985-0.2000008-0.2000008-0.2000008 c-0.5999985,0.2999992-1.2999992,0.5999985-2,0.7999992c-0.0999985,0,0.0999985,0.2000008,0.2000008,0.2000008 c0.2000008,0,0.2999992-0.0999985,0.5-0.0999985c0,0.0999985,0.0999985,0.2000008,0.2000008,0.2000008h0.0999985 c0,0,0,0,0.0999985,0s0.0999985,0,0.2000008-0.0999985c0.4000015-0.0999985,0.9000015-0.2000008,1.2999992-0.2999992 C62.4000015,41.4000015,62.2000008,41.2000008,62.0999985,41.2000008z"
            />
            <path
              fill="url(#SVGID_42_)"
              d="M61,45.5C61,45.5,61.0999985,45.5,61,45.5 c0.0999985-0.0999985,0.0999985-0.2000008,0-0.2999992c0,0,0,0,0.0999985,0c0,0-0.0999985-0.2999992-0.2000008-0.2000008 c-0.4000015,0.2000008-0.7999992,0.5-1.2000008,0.7000008v0.0999985c-0.0999985,0-0.2000008,0.0999985-0.2999992,0.0999985 s0.0999985,0.2000008,0.2000008,0.2000008C59.6999969,46.0999985,59.7999992,46,59.8999977,46 c-0.0999985,0-0.2000008,0.0999985-0.2000008,0.0999985s0.0999985,0.2000008,0.2000008,0.2000008 c0.4000015-0.2000008,0.9000015-0.4000015,1.2999992-0.7000008C61.2000008,45.5999985,61.0999985,45.5,61,45.5z"
            />
            <path
              fill="url(#SVGID_43_)"
              d="M64.8000031,37.5c-1,0.7000008-1.5999985,1.7000008-2.2000008,2.7999992 c0,0.0999985,0.2000008,0.2999992,0.2000008,0.2000008C63.4000015,39.5,64,38.4000015,65,37.7000008 C65,37.5999985,64.8000031,37.4000015,64.8000031,37.5z"
            />
            <path
              fill="url(#SVGID_44_)"
              d="M74.6999969,40.7000008C74.3999939,40.2999992,74.2999954,39.7999992,74,39.4000015 C73.8000031,39.1000023,73.5999985,38.8000031,73.3000031,38.5c-0.0999985-0.0999985-0.1999969-0.2000008-0.0999985,0 c0.3000031,0.4000015,0.5999985,0.7999992,0.8000031,1.2999992c0.0999985,0.2999992,0.3000031,0.5999985,0.5,0.9000015 C74.5999985,40.7999992,74.8000031,40.9000015,74.6999969,40.7000008z"
            />
            <path
              fill="url(#SVGID_45_)"
              d="M64.0999985,36.7999992c0,0-0.0999985-0.2000008-0.2000008-0.2000008 c0-0.0999985,0.0999985-0.2000008,0.0999985-0.2999992S63.7999954,36,63.7999954,36.0999985 C63.6999969,36.1999969,63.5999947,36.3999977,63.5999947,36.5c0-0.2000008,0-0.4000015,0.0999985-0.5999985 c0-0.0999985-0.2000008-0.2000008-0.2000008-0.2000008c0,0.0999985,0,0.0999985,0,0.2000008 c0-0.0999985,0-0.2000008,0-0.2999992s-0.2000008-0.2000008-0.2000008-0.0999985 c0.0999985,0.4000015,0.0999985,0.7999992,0.0999985,1.2000008c0,0.0999985-0.0999985,0.2999992-0.0999985,0.4000015 c0,0.0999985,0.2000008,0.2000008,0.2000008,0.2000008l0,0c0.0999985,0,0.0999985,0.0999985,0.0999985,0.0999985 c0-0.0999985,0-0.0999985,0-0.2000008l0,0l0,0l0.0999985,0.0999985l0.0999985-0.0999985l0,0 C64,36.9000015,64.0999985,36.7999992,64.0999985,36.7999992z"
            />
            <path
              fill="url(#SVGID_46_)"
              d="M68.5999985,36.0999985c-0.0999985,0-0.1999969,0.0999985-0.1999969,0.0999985 c0.1999969-0.2000008,0.4000015-0.2999992,0.5999985-0.5c0.0999985-0.0999985-0.1999969-0.2999992-0.1999969-0.2000008 C68.7000046,35.5999947,68.6000061,35.6999969,68.5,35.7999954l0.5-0.5999985 c0-0.0999985-0.1999969-0.2999992-0.1999969-0.2000008c-0.0999985,0.2000008-0.3000031,0.2999992-0.4000015,0.5 c0.0999985-0.0999985,0.1999969-0.2999992,0.1999969-0.4000015c0.0999985-0.2000008,0.1999969-0.4000015,0.0999985-0.5999985 c0,0,0,0-0.0999985-0.0999985c0.0999985-0.2000008,0-0.2999992,0.0999985-0.5999985 c0-0.0999985-0.0999985-0.4000015-0.0999985-0.2999992C68.4000015,34.0999985,68.1999969,34.7999992,68,35.5 c-0.0999985,0.2000008-0.0999985,0.4000015-0.1999969,0.5999985c0,0.0999985-0.0999985,0.2000008,0,0.2000008v0.0999985 C67.8000031,36.4999962,68,36.5999985,68,36.5999985V36.5c0,0.0999985,0.0999985,0.0999985,0.0999985,0.0999985 c0.1999969-0.0999985,0.5-0.2000008,0.6999969-0.2999992C68.8000031,36.2999992,68.6999969,36.0999985,68.5999985,36.0999985z"
            />
            <path
              fill="url(#SVGID_47_)"
              d="M73.5999985,36c0.0999985-0.0999985,0.1999969-0.2000008,0.3000031-0.2999992 c0.0999985,0-0.0999985-0.2999992-0.1999969-0.2000008c-0.5,0.5-1.0999985,1-1.5999985,1.5 c-0.0999985,0.0999985,0.0999985,0.2999992,0.1999969,0.2000008s0.3000031-0.2999992,0.4000015-0.4000015l0.0999985,0.0999985 c0,0,0,0,0.0999985,0c0,0,0.0999985,0.2000008,0.1999969,0.2000008c0,0-0.0999985-0.2000008-0.1999969-0.2000008 c0.1999969-0.0999985,0.4000015-0.2000008,0.5999985-0.2000008c0,0-0.0999985-0.2000008-0.1999969-0.2000008l0,0 c0.0999985-0.0999985,0.3000031-0.2000008,0.4000015-0.2000008C73.6999969,36.0999985,73.6999969,36.0999985,73.5999985,36z"
            />
            <path
              fill="url(#SVGID_48_)"
              d="M77.5,40.9000015C77.4000015,41,77.5,41,77.3000031,41c0,0,0,0-0.0999985,0 c0,0,0,0-0.0999985,0s-0.3000031,0-0.4000015,0c-0.4000015,0-0.9000015,0-1.3000031-0.2999992 c-0.0999985-0.0999985,0,0.0999985,0.0999985,0.2000008c-0.1999969,0-0.3000031-0.0999985-0.5-0.0999985 c-0.0999985,0,0,0.0999985,0,0.0999985s0,0-0.0999985,0l0,0l0,0c0,0.0999985,0.1999969,0.2000008,0.1999969,0.2000008 c0,0.0999985,0.8000031,0.2000008,1,0.2000008c0.4000015,0,0.8000031,0,1.1999969-0.2000008 c0.1999969,0,0.0999985,0,0.1999969-0.0999985C77.5999985,41,77.5,40.7999992,77.5,40.9000015z"
            />
            <path
              fill="url(#SVGID_49_)"
              d="M76,45.4000015C76,45.4000015,75.9000015,45.4000015,76,45.4000015 c-0.0999985-0.0999985-0.0999985-0.2000008,0-0.2999992c0,0,0,0-0.0999985,0c0,0,0.0999985-0.2999992,0.1999969-0.2000008 c0.4000015,0.2000008,0.8000031,0.5,1.1999969,0.7000008v0.0999985c0.0999985,0,0.1999969,0.0999985,0.3000031,0.0999985 C77.6999969,45.7999992,77.5,46,77.4000015,46s-0.1999969-0.0999985-0.3000031-0.0999985 C77.1999969,45.9000015,77.2999954,46,77.2999954,46s-0.0999985,0.2000008-0.1999969,0.2000008 C76.6999969,46,76.1999969,45.7999992,75.7999954,45.5C75.8000031,45.5,75.9000015,45.4000015,76,45.4000015z"
            />
          </g>
        </g>
      </g>
      <linearGradient
        id="SVGID_8_"
        gradientUnits="userSpaceOnUse"
        x1="68.46"
        y1="-536.285"
        x2="68.66"
        y2="-528.204"
        gradientTransform="matrix(1 0 0 -1 0 -488)"
      >
        <stop offset="0" stopColor="#fff" />
        <stop offset="0.742" stopColor="#fff" stopOpacity="0" />
      </linearGradient>
    </g>
  )
}

export default DragonSkull
